<template>
   	<div class="bg">
   		<v-banner></v-banner>
   		<v-songlist></v-songlist>
   	</div>
</template>

<script>
import banner from '../components/banner2.vue'
import songList from '../components/songList.vue'
  export default {
    data () {
      return {
      
      }
    },
    components:{
	  'v-banner':banner,
	  'v-songlist':songList,
  	},
    mounted:function(){
	var _this=this;
	//this.$nextTick(function(){ //会导致第一次startView失效
		this.startView();
	//})
    },
    methods: {
      startView:function(){
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/newSongList?url=",
			success: function(data){		
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('.panel-songslist-item');
				var songList = [];
				for(var i=0;i<list.length;i++){
					var song={};
					song.title=list[i].querySelector('.panel-songs-item-name span').textContent;
					song.hash=list[i].id.substr(6);
					songList.push(song);
				}
				_this.$store.commit('setGuodu', false);
				_this.$store.commit('setSongList', songList);
			},
			error:function(){
				alert(-1)
			}
		});
      },
    }
  }
</script>

<style scoped>
.songList{z-index: 8;top:260px}
.bg{width: 100%;height: 100%;overflow: hidden;background: url(../assets/images/bg01.jpg);background-size:15%; }
@media only screen and (max-width: 321px) {
    #app .songList{top:242px;}
}
/*@media only screen and (min-width: 376px) {
    #app .songList{top:273px;}
}*/
@media only screen and (min-width: 1367px) {
    #app .songList{top:305px;}
}
</style>


// WEBPACK FOOTER //
// index.vue?d4e3df3c